// src/components/ui/Card.jsx
export function Card({ children, className = "" }) {
  return (
    <div className={`rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-800 shadow-sm ${className}`}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, right }) {
  return (
    <div className="border-b dark:border-slate-800 p-4 flex items-start justify-between gap-4">
      <div>
        <div className="font-semibold text-slate-900 dark:text-slate-100">{title}</div>
        {subtitle ? (
          <div className="text-sm text-slate-500 dark:text-slate-500">{subtitle}</div>
        ) : null}
      </div>
      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}

export function CardBody({ children, className = "" }) {
  return <div className={`p-4 ${className}`}>{children}</div>;
}